import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import HowItWorks from 'shared-components/HowItWorks/HowItWorks';
import SectionTitle from '../SectionTitle/SectionTitle';
import styles from './HowTheSaleWorks.module.css';

const HowTheSaleWorks = ({ userType, campaignEndDatePlusSeven }) => {
  const copy = {
    redeemed: [
      {
        icon: 'fal fa-mail-bulk',
        title: 'Send Your Invites',
        copy:
          'Give your friends who are new to FabFitFun a chance to treat themselves!',
      },
      {
        icon: 'fal fa-shopping-bag',
        title: 'Shop the Sale',
        copy:
          "Share what's in your cart, chat about your favorite finds -- it's like a virtual trip to the mall!",
      },
      {
        icon: 'fal fa-badge-dollar',
        title: 'Earn Credit',
        copy:
          'Get a <strong>$10 credit</strong> to use in the sale when both you and the hosting member purchase a product.',
      },
      {
        icon: 'fal fa-smile',
        title: 'Get Excited',
        copy:
          'Enjoy all your new products delivered straight to your doorstep. Your items will generally ship within 2 weeks of your bill date.',
      },
    ],
    member: [
      {
        icon: 'fal fa-mail-bulk',
        title: 'Send Your Invites',
        copy:
          'Give your friends who are new to FabFitFun a chance to treat themselves!',
      },
      {
        icon: 'fal fa-shopping-bag',
        title: 'Shop the Sale',
        copy:
          "Share what's in your cart, chat about your favorite finds -- it's like a virtual trip to the mall!",
      },
      {
        icon: 'fal fa-badge-dollar',
        title: 'Earn Credit',
        copy: `You'll earn credits for making eligible purchases and get an <strong>extra $15 credit</strong> for each friend that becomes a member by ${campaignEndDatePlusSeven}.`,
      },
      {
        icon: 'fal fa-smile',
        title: 'Get Excited',
        copy:
          'Enjoy all your new products delivered straight to your doorstep. Your items will generally ship within 2 weeks of your bill date.',
      },
    ],
  };
  const sections = get(copy, userType, []);

  return (
    <div>
      <SectionTitle
        title="How to Shop with Friends"
        subtitle="We're taking the best of our e-comm sales, but now shareable with your favorite people!"
        titleClassName={styles.title}
      />
      <HowItWorks sections={sections} className={styles.howItWorks} />
    </div>
  );
};

HowTheSaleWorks.propTypes = {
  userType: PropTypes.string.isRequired,
  campaignEndDatePlusSeven: PropTypes.string.isRequired,
};

export default HowTheSaleWorks;
